import axios from '@/plugins/axios.js';

/**
 * The learner's pre-submit late notice. Resolves to the pending deduction, or null when
 * submitting now would cost nothing (on time, within grace, no policy, extension, waiver).
 * A 403 here means the viewer is staff, not an enrolled learner, so it must not trigger
 * the global Access Denied redirect.
 */
const pendingLateDeductionService = {
    async getForActivity(activityId) {
        const response = await axios.get(`/api/activities/${activityId}/pending-late-deduction`, {
            errorHandle: false,
        });

        return response.data.data ?? null;
    },
};

export default pendingLateDeductionService;
